module.exports = __webpack_public_path__ + "static/media/ene-ending.882a3f91.mp3";